<template>
  <div class="flex-wrap table-filter-item">
    <div v-if="label" class="flex-align-center table-filter-label">{{label}}：</div>
    <div v-if="!isHideQuickTime" class="quick-time-button-box">
      <span
        :class="`quick-time-button quick-time-button-${size}${v === quickTimeLimit ? ' quick-time-checked' : ''}`"
        v-for="v in quickTimes"
        :key="v"
        @click="handleQuickTimeLimitChange(v)"
      >
        {{ v }}
      </span>
    </div>
    <el-date-picker
      unlink-panels
      type="daterange"
      align="right"
      value-format="yyyy-MM-dd"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      v-model="timeLimit"
      :pickerOptions="pickerOptions"
      :size="size"
    >
    </el-date-picker>
  </div>
</template>

<script>
import * as formats from '@/utils/formats';

export default {
  data() {
    const quickTimes = {
      all: '全部',
      today: '今天',
      yesterday: '昨天',
    };
    if (this.isShowWeek) quickTimes.week = '过去7天';
    if (this.isShowNextWeek) quickTimes.nextWeek = '未来7天';
    if (this.isShowMonth) quickTimes.month = '本月';
    if (this.isShowLastMonth) quickTimes.lastMonth = '上月';
    if (this.isShowLastThirtyDay) quickTimes.lastThirtyDay = '过去30天';
    return {
      quickTimeLimit: '全部',
      timeLimit: [],
      quickTimes,
    };
  },
  props: {
    value: {
      type: Array,
    },
    pickerOptions: Object,
    isShowWeek: {
      type: Boolean,
      default: true,
    },
    isShowNextWeek: Boolean,
    isShowLastThirtyDay: Boolean,
    isShowMonth: Boolean,
    isShowLastMonth: Boolean,
    isHideQuickTime: Boolean,
    size: {
      type: String,
      default: 'medium',
    },
    label: {
      type: String,
      default: '',
    },
  },
  watch: {
    value(timeLimit) {
      if (JSON.stringify(this.timeLimit) === JSON.stringify(timeLimit)) return;

      this.timeLimit = timeLimit;
      this.setQuickTimeLimit(timeLimit);
    },
    timeLimit(timeLimit) {
      if (JSON.stringify(this.value) === JSON.stringify(timeLimit)) return;

      this.setQuickTimeLimit(timeLimit);
      this.$emit('input', timeLimit);
    },
  },
  methods: {
    setQuickTimeLimit(timeLimit) {
      if (formats.isToday(timeLimit)) {
        this.quickTimeLimit = this.quickTimes.today;
      } else if (formats.isYesterday(timeLimit)) {
        this.quickTimeLimit = this.quickTimes.yesterday;
      } else if (this.quickTimes.week && formats.isWeek(timeLimit)) {
        this.quickTimeLimit = this.quickTimes.week;
      } else if (this.quickTimes.nextWeek && formats.isNextWeek(timeLimit)) {
        this.quickTimeLimit = this.quickTimes.nextWeek;
      } else if (this.quickTimes.lastThirtyDay && formats.isMonth(timeLimit)) {
        this.quickTimeLimit = this.quickTimes.lastThirtyDay;
      } else if (this.quickTimes.month && formats.isCurrentMonth(timeLimit)) {
        this.quickTimeLimit = this.quickTimes.month;
      } else if (this.quickTimes.lastMonth && formats.isLastMonth(timeLimit)) {
        this.quickTimeLimit = this.quickTimes.lastMonth;
      } else {
        this.quickTimeLimit = this.quickTimes.all;
      }
    },
    setAll() {
      this.timeLimit = [];
    },
    setToday() {
      const time = formats.getDay();
      this.timeLimit = [time, time];
    },
    setYesterday() {
      const time = formats.getLatelyDay();
      this.timeLimit = [time, time];
    },
    setWeek() {
      this.timeLimit = [formats.getLatelyDay(5184e5), formats.getDay()];
    },
    setNextWeek() {
      this.timeLimit = [formats.getDay(), formats.getFutureDay(5184e5)];
    },
    setLastThirtyDay() {
      this.timeLimit = [formats.getLatelyDay(25056e5), formats.getDay()];
    },
    setMonth() {
      // 本月：从本月 1 号到今天
      this.timeLimit = [formats.getMonthStart(), formats.getDay()];
    },
    setLastMonth() {
      // 上月：上一个自然月的完整起止日期
      this.timeLimit = [formats.getLastMonthStart(), formats.getLastMonthEnd()];
    },
    handleQuickTimeLimitChange(quickTimeLimit) {
      if (this.quickTimeLimit === quickTimeLimit) return;
      this.quickTimeLimit = quickTimeLimit;

      const { quickTimes } = this;
      switch (quickTimeLimit) {
        case quickTimes.all:
          this.setAll();
          break;
        case quickTimes.today:
          this.setToday();
          break;
        case quickTimes.yesterday:
          this.setYesterday();
          break;
        case quickTimes.week:
          this.setWeek();
          break;
        case quickTimes.nextWeek:
          this.setNextWeek();
          break;
        case quickTimes.lastThirtyDay:
          this.setLastThirtyDay();
          break;
        case quickTimes.month:
          this.setMonth();
          break;
        case quickTimes.lastMonth:
          this.setLastMonth();
          break;
        default:
      }
    },
  },
  created() {
    // 组件首次挂载时把父级传入的日期回显到内部 picker，避免跳转链接带参数但日期框为空
    this.timeLimit = Array.isArray(this.value) ? this.value : [];
    this.setQuickTimeLimit(this.timeLimit);
  },
};
</script>

<style scoped>
.quick-time-button-box {
  /*display: inline-block;
  line-height: 1;
  vertical-align: middle;*/
  display: flex;
  justify-content: center;
  margin-right: 6px;
}

.quick-time-button {
  display: inline-block;
  padding: 12px 20px;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  background: #fff;
  border: 1px solid #dcdfe6;
  font-weight: 500;
  border-left: 0;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  transition: all .3s cubic-bezier(.645, .045, .355, 1);
  font-size: 14px;
  border-radius: 0;
}

.quick-time-button-small {
  padding: 9px 20px;
  font-size: 12px;
}

.quick-time-button:first-child {
  border-left: 1px solid #dcdfe6;
  border-radius: 4px 0 0 4px;
  box-shadow: none !important;
}

.quick-time-button:last-child {
  border-radius: 0 4px 4px 0;
}

.quick-time-button:hover {
  color: #409EFF;
}

.quick-time-checked {
  color: #fff;
  background-color: #409EFF;
  border-color:#409EFF;
  box-shadow: -1px 0 0 0 #409EFF;
}

.quick-time-checked:hover {
  color: #fff;
}

@media screen and (min-width:1921px) {

}

@media screen and (min-width: 1200px) and (max-width: 1920px) {

}
@media screen and (min-width: 960px) and (max-width: 1199px) {

}
@media screen and (min-width: 768px) and (max-width: 959px) {

}
@media only screen and (min-width: 480px) and (max-width: 767px){

}
@media only screen and (max-width: 479px) {
  .quick-time-button-small {
    display: flex;
    align-items: center;
    height: 8vw;
    padding: 0 3.4vw;
    font-size: 3vw;
  }

  .quick-time-button-box {
    padding-bottom: 3vw;
  }

  /deep/.el-date-range-picker__content {
    width: 80vw !important;
  }
}
</style>
